
/*

ashraf 09/30/2022 2805569304 fixed ssn and phone format bugs

*/

const formatSsnNumber = (number) => {
  const ssnNumberString = number ? number.toString() : null;
  if (ssnNumberString) {
    if (ssnNumberString?.length > 6) {
      return (
        ssnNumberString.slice(0, 3) +
      '-' +
      ssnNumberString.slice(3, 5) +
      '-' +
      ssnNumberString.slice(5, ssnNumberString.length)
      );
    } else if (ssnNumberString?.length <= 3) {
      return '(' + ssnNumberString + ')   ' + '-';
    // return "(" + match[1] + ") " + match[2] + "-" + match[3];
    } else if (ssnNumberString?.length > 3 && ssnNumberString?.length <= 6) {
      return (
        '(' +
      ssnNumberString.slice(0, 3) +
      ') ' +
      ssnNumberString.slice(3, ssnNumberString.length) +
      '-'
      );
    }
  }
  return null;
};
export default formatSsnNumber;
